var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00001 0.541992C1.73436 0.541992 0.708344 1.56801 0.708344 2.83366C0.708344 4.09931 1.73436 5.12533 3.00001 5.12533C4.26566 5.12533 5.29168 4.09931 5.29168 2.83366C5.29168 1.56801 4.26566 0.541992 3.00001 0.541992ZM1.95834 2.83366C1.95834 2.25836 2.42471 1.79199 3.00001 1.79199C3.57531 1.79199 4.04168 2.25836 4.04168 2.83366C4.04168 3.40896 3.57531 3.87533 3.00001 3.87533C2.42471 3.87533 1.95834 3.40896 1.95834 2.83366Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 2.20866C7.65483 2.20866 7.37501 2.48848 7.37501 2.83366C7.37501 3.17884 7.65483 3.45866 8.00001 3.45866L14.6667 3.45866C15.0119 3.45866 15.2917 3.17884 15.2917 2.83366C15.2917 2.48848 15.0119 2.20866 14.6667 2.20866L8.00001 2.20866Z",
    fill: "#0D0D0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8.87533C11.7344 8.87533 10.7083 9.90134 10.7083 11.167C10.7083 12.4326 11.7344 13.4587 13 13.4587C14.2657 13.4587 15.2917 12.4326 15.2917 11.167C15.2917 9.90134 14.2657 8.87533 13 8.87533ZM11.9583 11.167C11.9583 10.5917 12.4247 10.1253 13 10.1253C13.5753 10.1253 14.0417 10.5917 14.0417 11.167C14.0417 11.7423 13.5753 12.2087 13 12.2087C12.4247 12.2087 11.9583 11.7423 11.9583 11.167Z",
    fill: "#0D0D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 10.542C0.988166 10.542 0.708344 10.8218 0.708344 11.167C0.708344 11.5122 0.988165 11.792 1.33334 11.792L8.00001 11.792C8.34519 11.792 8.62501 11.5122 8.62501 11.167C8.62501 10.8218 8.34519 10.542 8.00001 10.542H1.33334Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.bec0e7801ec9fdd834be1dd3b78fa2fb.svg";
export { ForwardRef as ReactComponent };